import { OutputHelper } from '../interfaces/output-helper.interface';

export const OUTPUT_HELPERS_CONFIG: () => OutputHelper[] = (): OutputHelper[] => [
    {
        title: 'View Results in a Table',
        query: 'view results in a table',
        iconType: 'table',
        iconSize: 'large',
        iconColor: '--colors-text-gray-700',
        isChecked: false,
        tooltip: 'Display results in a table',
        id: 0
    },
    {
        title: 'List',
        query: 'view results in a list',
        iconType: 'table',
        iconSize: 'large',
        iconColor: '--colors-text-gray-700',
        isChecked: false,
        tooltip: 'Display results as a simple list',
        id: 1
    },
    {
        title: 'Include Summary',
        query: 'include a summary',
        iconType: 'clipboard',
        iconSize: 'large',
        iconColor: '--colors-text-gray-700',
        isChecked: false,
        tooltip: 'Generate and display a summary of the results along with the data',
        id: 2
    }
];
